"use strict";import{IconAsterisk100 as e}from"../src/elements/IconAsterisk100.js";import{defineElement as i}from"@spectrum-web-components/base/src/define-element.js";i("sp-icon-asterisk100",e);
//# sourceMappingURL=sp-icon-asterisk100.js.map
